import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import type { SelectedDriver } from '@/app/types/creator'
import { stashCreatorWizardResume } from '@/modules/home/creatorWizardResumeStorage'

export type EditBusinessTripOpenLocationState = {
  returnTo: { pathname: string; search: string }
  creatorWizard: {
    step: number
    subStep: number
    selectedDrivers?: SelectedDriver[]
  }
}


export const EditBusinessTripOnCloseContext = React.createContext<
  ((opts?: { saved?: boolean }) => void) | null
>(null)

/**
 * Hook that returns a "go back" handler for the edit-business-trip view. If
 * an onClose context is provided (in-place modal mode), it is invoked.
 * Otherwise, if the route was opened from the creator wizard (via
 * `location.state`), it navigates back to the wizard's return URL and stashes
 * the resume state; otherwise it just pops one entry from history.
 */
export function useNavigateBackFromEditBusinessTrip() {
  const navigate = useNavigate()
  const location = useLocation()
  const onClose = React.useContext(EditBusinessTripOnCloseContext)

  return (opts?: { saved?: boolean }) => {
    if (onClose) {
      onClose(opts)
      return
    }
    const state = location.state as
      | EditBusinessTripOpenLocationState
      | null
      | undefined
    if (state?.returnTo && state?.creatorWizard) {
      const path = `${state.returnTo.pathname}${state.returnTo.search || ''}`
      stashCreatorWizardResume(path, state.creatorWizard)
      navigate(path)
    } else {
      navigate(-1)
    }
  }
}
